import { render } from "./RefundsDetail.vue?vue&type=template&id=6297b2e2"
import script from "./RefundsDetail.vue?vue&type=script&lang=js"
export * from "./RefundsDetail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RefundsDetail.vue?vue&type=style&index=0&id=6297b2e2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__